import React from "react";

import "../SCSS/styles.css";
import assets from "../../../../../shared/constants/assetVariables";

function Faqs({ activeIndex, toggleAccordion, faqList }) {
  return (
    <section className="common-faqs-container">
      <div className="csrd-landing-page-section-11-inner-container">
        <div className="section-11-header">FREQUENTLY ASKED QUESTIONS</div>
        <div className="section-11-content-container">
          <div className="section-11-left-container">
            <div className="faq-image-container">
              <img
                src={assets.images.faqImage1}
                alt="faq-image_1"
                className="faq-image-1"
                width="90%"
              />
            </div>
          </div>
          <div className="section-11-right-container">
            {/* <img
              src={assets.images.faqImage2}
              alt="faq-image_2"
              className="faq-image-2"
              size="20%"
            /> */}
            {faqList.map((item) => (
              <div key={item.id}>
                <button
                  className={`accordion accordion${item.id} ${
                    activeIndex === item.id ? "active" : ""
                  }`}
                  onClick={() => toggleAccordion(item.id)}
                >
                  <div className="expand-icon">
                    {activeIndex === item.id ? (
                      <img src={assets.icons.accord_minus} width="17px" />
                    ) : (
                      <img src={assets.icons.accord_plus} width="17px" />
                    )}
                  </div>
                  <div className="question">{item.question}</div>
                </button>
                <div
                  className={`panel panel${item.id}`}
                  style={{
                    maxHeight: activeIndex === item.id ? "fit-content" : "0px",
                    overflow: "hidden",
                    transition: "max-height 01s ease",
                  }}
                >
                  <p
                    className="answer"
                    style={!item?.answerList ? { paddingBottom: "10px" } : {}}
                  >
                    {item.answer}
                  </p>
                  {item.paragraphList &&
                    item.paragraphList.map((listItem) => (
                      <p
                        key={listItem}
                        className="answer"
                        style={
                          !item?.answerList ? { paddingBottom: "10px" } : {}
                        }
                      >
                        {listItem}
                      </p>
                    ))}
                  {item.answerList && (
                    <ul className="answer-list">
                      {item.answerList.map((listItem) => (
                        <li key={listItem}>{listItem}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faqs;
